/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_PermissionUser } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TClientType,
  TConcreteStrengthCertificateType,
  TConcretingType,
  TConstructionType,
  TContractSellerType,
  TContractType,
  TInvoiceType,
  TJoin,
  TModuleType,
  TNonEmptyArray,
  TPermissionUserType,
  TSellerType,
  TUserType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TPermissionUserType
  | TJoin<"user", TUserType>
  | TJoin<"construction", TConstructionType>
  | TJoin<"construction.client", TClientType>
  | TJoin<"contract", TContractType>
  | TJoin<"contract.contractSellers", TContractSellerType>
  | TJoin<"contract.contractSellers.seller", TSellerType>
  | TJoin<"contract.concretings", TConcretingType>
  | TJoin<"contract.construction", TConstructionType>
  | TJoin<"contract.construction.client", TClientType>
  | TJoin<
      "contract.concretings.concreteStrengthCertificates",
      TConcreteStrengthCertificateType
    >
  | TJoin<"contract.invoices", TInvoiceType>
  | TJoin<"module", TModuleType>;

type TPermissionUserCreateFunctions = { create: CommandResult_PermissionUser };
export type TPermissionUserCreateMutations = {
  permissionUser: TPermissionUserCreateFunctions;
};
export const permissionUserCreate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation permissionUserCreate($permissionUser: PermissionUserCreateInputType!) {
    permissionUser {
      create(permissionUser: $permissionUser) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_PermissionUser")}
`;

type TPermissionUserUpdateFunctions = { update: CommandResult_PermissionUser };
export type TPermissionUserUpdateMutations = {
  permissionUser: TPermissionUserUpdateFunctions;
};
export const permissionUserUpdate = (fields: TNonEmptyArray<TGlobal>) => gql`
  mutation permissionUserUpdate($permissionUser: PermissionUserUpdateInputType!) {
    permissionUser {
      update(permissionUser: $permissionUser) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_PermissionUser")}
`;

type TPermissionUserDeleteFunctions = { delete: CommandResult_PermissionUser };
export type TPermissionUserDeleteMutations = {
  permissionUser: TPermissionUserDeleteFunctions;
};
export const permissionUserDelete = () => gql`
  mutation permissionUserDelete($id: Guid!, $permanent: Boolean) {
    permissionUser {
      delete(id: $id, permanent: $permanent) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
